import InfoCardSubLabelComponent from './InfoCardSubLabelComponent';
export * from './InfoCardSubLabelComponent';
export default InfoCardSubLabelComponent;
